import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="U" transform="translate(10.5, 0)">
        <path
          d="M25,33 L25,58 C25,65.5 31,71 40,71 C49,71 55,65.5 55,58 L55,33 L48.5,33 L48.5,58 C48.5,62 44.5,67 40,67 C35.5,67 31.5,62 31.5,58 L31.5,33 L25,33 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5 L 11, 27 L 11, 72 L 50, 95 L 89, 73 L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
